import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';


export const Form = styled.form`
	display: flex;
	flex-direction: column;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
    margin-bottom: 40px;
    margin-left: 10px;
`;

export const InputsContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	margin-bottom: 20px;
`;

export const Splitter = styled.div`
	width: 100%;
	height: 2px;
	background-color: ${Colors.darkGray};
	margin: 18px 0;
`;